import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { DEFAULT_LANG } from './i18n/languages';

import en from './locales/en.json';
import hy from './locales/hy.json';
import ru from './locales/ru.json';
import fr from './locales/fr.json';
import ka from './locales/ka.json';
import it from './locales/it.json';
import zh from './locales/zh.json';

// Language is driven by the URL prefix (see LangLayout), not by a
// browser/localStorage detector — the route is the single source of truth.
const resources = {
  en: { translation: en },
  hy: { translation: hy },
  ru: { translation: ru },
  fr: { translation: fr },
  ka: { translation: ka },
  it: { translation: it },
  zh: { translation: zh },
};

i18n.use(initReactI18next).init({
  resources,
  lng: DEFAULT_LANG,
  fallbackLng: DEFAULT_LANG,
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
